export const getMonthName = month => {
  switch (month) {
    case 1: {
      return "JAN";
    }
    case 2: {
      return "FEV";
    }
    case 3: {
      return "MAR";
    }
    case 4: {
      return "AVR";
    }
    case 5: {
      return "MAI";
    }
    case 6: {
      return "JUN";
    }
    case 7: {
      return "JUL";
    }
    case 8: {
      return "AOU";
    }
    case 9: {
      return "SEP";
    }
    case 10: {
      return "OCT";
    }
    case 11: {
      return "NOV";
    }
    case 12: {
      return "DEC";
    }
    default: {
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/capacityPlaning.js